import { useSelector } from 'react-redux';

import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';
import Global from '../store/global-selectors';

/**
 * Custom hook to check if ShipStationApiV2 feature is available and if InventoryApi is not available as an add-on.
 * This is used to conditionally show/hide the Inventory API promotional banners.
 * @returns {{ isInventoryApiEnabled: boolean, isApiFeatureEnabled: boolean }}
 */
export const useApiFeatureGate = () => {
  // Check if ShipStationApiV2 feature is available using existing hook
  const { isFeatureEnabled: isApiFeatureEnabled } = usePlanFeatureGate(Features.ShipStationApiV2);
  // Get subscription plan info to check available add-ons
  const { marketplaceAddOns = [] } = useSelector(Global.selectSellerSubscriptionPlanInfo) || {};

  // Check if InventoryApi is available as a marketplace add-on
  const isInventoryApiAddOnAvailable = marketplaceAddOns.some((addon) => addon.code === Features.InventoryApi);

  // Return combined result
  return {
    isInventoryApiEnabled: isApiFeatureEnabled && isInventoryApiAddOnAvailable,
    isApiFeatureEnabled,
  };
};
